// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vault_message_type.proto (package domain, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file vault_message_type.proto.
 */
export const file_vault_message_type: GenFile = /*@__PURE__*/
  fileDesc("Chh2YXVsdF9tZXNzYWdlX3R5cGUucHJvdG8SBmRvbWFpbiqCAwoQVmF1bHRNZXNzYWdlVHlwZRIeChpWQVVMVF9NRVNTQUdFX1RZUEVfVU5LTk9XThAAEiUKIVZBVUxUX01FU1NBR0VfVFlQRV9MT0dJTl9JTkJPWF9WMRABEiUKIVZBVUxUX01FU1NBR0VfVFlQRV9MT0dJTl9JTkJPWF9WMhAGEicKI1ZBVUxUX01FU1NBR0VfVFlQRV9WQVVMVF9ERUxFVEVEX1YxEAMSKwonVkFVTFRfTUVTU0FHRV9UWVBFX1NIQVJFX0xJTktfT1BFTkVEX1YxEAQSKwonVkFVTFRfTUVTU0FHRV9UWVBFX1NZTkNfTkFNRV9DSEFOR0VEX1YxEAcSLQopVkFVTFRfTUVTU0FHRV9UWVBFX0xJTktFRF9MT0dJTl9VUERBVEVfVjEQAhIuCipWQVVMVF9NRVNTQUdFX1RZUEVfTE9HSU5fU1VNTUFSWV9VUERBVEVfVjEQBRIeChhWQVVMVF9NRVNTQUdFX1RZUEVfREVCVUcQv4Q9QjBaLmdpdGxhYi5jb20vY290ZWNoZGUvbW9ub3JlcG8vYmFja2VuZC9kb21haW4vcGJiBnByb3RvMw");

/**
 * @generated from enum domain.VaultMessageType
 */
export enum VaultMessageType {
  /**
   * used as default value, see https://developers.google.com/protocol-buffers/docs/proto3#enum
   *
   * @generated from enum value: VAULT_MESSAGE_TYPE_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * generated by backend
   *
   * @generated from enum value: VAULT_MESSAGE_TYPE_LOGIN_INBOX_V1 = 1;
   */
  LOGIN_INBOX_V1 = 1,

  /**
   * @generated from enum value: VAULT_MESSAGE_TYPE_LOGIN_INBOX_V2 = 6;
   */
  LOGIN_INBOX_V2 = 6,

  /**
   * @generated from enum value: VAULT_MESSAGE_TYPE_VAULT_DELETED_V1 = 3;
   */
  VAULT_DELETED_V1 = 3,

  /**
   * @generated from enum value: VAULT_MESSAGE_TYPE_SHARE_LINK_OPENED_V1 = 4;
   */
  SHARE_LINK_OPENED_V1 = 4,

  /**
   * @generated from enum value: VAULT_MESSAGE_TYPE_SYNC_NAME_CHANGED_V1 = 7;
   */
  SYNC_NAME_CHANGED_V1 = 7,

  /**
   * generated by frontend
   *
   * @generated from enum value: VAULT_MESSAGE_TYPE_LINKED_LOGIN_UPDATE_V1 = 2;
   */
  LINKED_LOGIN_UPDATE_V1 = 2,

  /**
   * @generated from enum value: VAULT_MESSAGE_TYPE_LOGIN_SUMMARY_UPDATE_V1 = 5;
   */
  LOGIN_SUMMARY_UPDATE_V1 = 5,

  /**
   * used to test client behaviour on unknown message types
   *
   * @generated from enum value: VAULT_MESSAGE_TYPE_DEBUG = 999999;
   */
  DEBUG = 999999,
}

/**
 * Describes the enum domain.VaultMessageType.
 */
export const VaultMessageTypeSchema: GenEnum<VaultMessageType> = /*@__PURE__*/
  enumDesc(file_vault_message_type, 0);

